var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { SelectPermissionsModalComponent } from '../../permissions/select-permissions-modal/select-permissions-modal.component';
import { SelectRolesModalComponent } from '../select-roles-modal/select-roles-modal.component';
import { User } from '../../../core/types/models/User';
import { Users } from '../../../auth/users.service';
import { RoleService } from '../../roles/role.service';
import { Modal } from '../../../core/ui/dialogs/modal.service';
var UserAccessManagerComponent = /** @class */ (function () {
    /**
     * UserAccessManagerComponent Constructor.
     */
    function UserAccessManagerComponent(userService, roleService, modal) {
        this.userService = userService;
        this.roleService = roleService;
        this.modal = modal;
        /**
         * User that's being edited.
         */
        this.user = new User();
        /**
         * Whether user access manager should be readonly
         * or allow adding/removing roles and permissions.
         */
        this.readonly = false;
    }
    /**
     * Called after data-bound properties of a directive are initialized.
     */
    UserAccessManagerComponent.prototype.ngOnInit = function () {
        this.fetchAllRoles();
    };
    /**
     * Open select roles modal.
     */
    UserAccessManagerComponent.prototype.openSelectRolesModal = function () {
        var _this = this;
        var selected = this.user.roles.map(function (role) { return role.id; });
        this.modal.open(SelectRolesModalComponent, { selected: selected }, 'select-roles-modal-container').afterClosed().subscribe(function (roles) {
            if (!roles)
                return;
            _this.attachRoles(roles);
        });
    };
    /**
     * Attach specified roles to user.
     */
    UserAccessManagerComponent.prototype.attachRoles = function (roles) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.attachRoles(this.user.id, { roles: roles }).toPromise().catch(function () { })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        roles.forEach(function (id) {
                            var role = _this.allRoles.find(function (role) { return role.id === id; });
                            if (role)
                                _this.user.roles.push(role);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Detach specified roles from user.
     */
    UserAccessManagerComponent.prototype.detachRoles = function (roles) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.detachRoles(this.user.id, { roles: roles }).toPromise().catch(function () { })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.user.roles = this.user.roles.filter(function (role) { return roles.indexOf(role.id) === -1; });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Open Selected permissions modal.
     */
    UserAccessManagerComponent.prototype.openSelectPermissionsModal = function () {
        var _this = this;
        this.modal.open(SelectPermissionsModalComponent, null, { panelClass: 'select-permissions-modal-container' }).afterClosed()
            .subscribe(function (permissions) {
            if (!permissions)
                return;
            _this.addPermissions(permissions);
        });
    };
    /**
     * Add specified permissions to user.
     */
    UserAccessManagerComponent.prototype.addPermissions = function (permissions) {
        return __awaiter(this, void 0, void 0, function () {
            var newPermissions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.addPermissions(this.user.id, { permissions: permissions }).toPromise().catch(function () { })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        newPermissions = {};
                        permissions.forEach(function (permission) {
                            newPermissions[permission] = 1;
                        });
                        this.user.permissions = Object.assign({}, this.user.permissions, newPermissions);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove specified permissions from user.
     */
    UserAccessManagerComponent.prototype.removePermissions = function (permissions) {
        return __awaiter(this, void 0, void 0, function () {
            var newPermissions, name_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.removePermissions(this.user.id, { permissions: permissions }).toPromise().catch(function () { })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        newPermissions = {};
                        for (name_1 in this.user.permissions) {
                            if (permissions.indexOf(name_1) === -1) {
                                newPermissions[name_1] = 1;
                            }
                        }
                        this.user.permissions = newPermissions;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch all available roles, if component is not in readonly mode.
     */
    UserAccessManagerComponent.prototype.fetchAllRoles = function () {
        var _this = this;
        if (this.readonly)
            return;
        this.roleService.getRoles()
            .subscribe(function (response) { return _this.allRoles = response.data; });
    };
    return UserAccessManagerComponent;
}());
export { UserAccessManagerComponent };
